<template>
    <div>
        {{data.IsFromZhenliu ? "是" : "否"}}
    </div>
</template>

<style lang="scss" scoped>
</style>

<script>

export default {
  props: {
    data: {},
    columnData:{},
    status: {}
  },
  data() {
    return {
    }
  },
  components: {},
  created() {
    
  },
  methods: {
  },
  watch: {
    data: function() {
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/paginationCells/zhenliuDetectCell.vue